export default "__VITE_ASSET__1a6ba921__"